import React, { Component } from "react";
import { currentLocals } from "../../languages/languages.js";
import ConverterManagerPool from "../../containers/ConverterManagerPoolContainer";
import ConverterConfig from "../../containers/ConverterConfigContainer";
import "../../styles/ConverterConfig.css";
import "../../styles/ConverterManager.css";
import { MuiDialog } from "@lectra/mui-library";
import { FormControl } from "@mui/material";
import { Typography } from "@mui/material";

export default class ConverterManager extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ello: 0,
    };
  }
  getElementsStartsWithId(id) {
    var children = document.body.getElementsByTagName("*");
    var elements = [],
      child;
    for (var i = 0, length = children.length; i < length; i++) {
      child = children[i];
      if (child.id.substr(0, id.length) == id) elements.push(child);
    }
    return elements;
  }
  onClose() {
    const { setConvertersManagerOpen } = this.props;
    let elements = this.getElementsStartsWithId("TextFieldConverter_");
    let bHayError = false;
    for (var i = 0; i < elements.length; i++) {
      elements[i].classList.add("helperText");
      if (elements[i].getAttribute("aria-invalid") === "true") {
        bHayError = true;
        break;
      }
    }
    //console.log("El elemento en bHayError  " + bHayError);
    if (!bHayError) setConvertersManagerOpen(false);
    // we put a vibration on elements[i]
  }
  render() {
    let ConvertersManagerOpen;
    if (this.props.isConvertersManagerOpen === true) ConvertersManagerOpen = true;
    else ConvertersManagerOpen = false;

    let ConverterConfigOpen;
    if (this.props.isConverterConfigOpen === true) ConverterConfigOpen = true;
    else ConverterConfigOpen = false;

    let converterTypeOnEdition, converterTypeOInOutOnEdition;
    let i = 0;
    let bFound = false;
    while (i < this.props.converters.length && !bFound) {
      if (this.props.converters[i].id === this.props.converterOnEdition) {
        bFound = true;
        converterTypeOnEdition = this.props.converters[i].type;
        converterTypeOInOutOnEdition = this.props.converters[i].typeInOut;
      }
      i++;
    }

    return (
      <div>
        <MuiDialog
          closeButton={<Typography style={{ color: "secondary" }}>Close</Typography>}
          maxWidth="md"
          closeButtonLabel={currentLocals(this.props.locale).welcome.Close}
          enableCloseIcon
          title={currentLocals(this.props.locale).converter.ConverterManagerConfiguration}
          //open={this.state.isPreferencesPopupOpened}
          open={ConvertersManagerOpen}
          //onClose={() => this.props.setConvertersManagerOpen(false)}
          onClose={() => this.onClose()}
          withDividers
          actions={{
            main: {
              kind: "secondary",
              label: currentLocals(this.props.locale).welcome.Close,
              onClick: () => this.props.setConverterConfigOpen(false),
            },
          }}
        >
          <ConverterManagerPool typeInOut="In"></ConverterManagerPool>
          <div>
            <br></br>
            <br></br>
            <br></br>
          </div>
          <ConverterManagerPool typeInOut="Out"></ConverterManagerPool>
        </MuiDialog>

        <MuiDialog
          closeButton={<Typography style={{ color: "secondary" }}>Close</Typography>}
          // ConverterConfig
          sx={{ margintop: 2, paddingLeft: 0 }}
          maxWidth="md"
          closeButtonLabel={currentLocals(this.props.locale).welcome.Close}
          enableCloseIcon
          title={currentLocals(this.props.locale).converter.Parameters + " " + this.props.converterOnEdition}
          open={ConverterConfigOpen}
          onClose={() => this.props.setConverterConfigOpen(false)}
          withDividers
        >
          <FormControl sx={{ m: 1, width: 200, display: "none" }}>
            <div
              id="converterconfigId"
              value={this.props.converterOnEdition}
              converterid={this.props.converterOnEdition}
              convertertype={converterTypeOnEdition}
            ></div>
          </FormControl>
          <ConverterConfig
            converterIdent={this.props.converterOnEdition}
            converterType={converterTypeOnEdition}
            converterTypeInOut={converterTypeOInOutOnEdition}
          />
        </MuiDialog>
      </div>
    );
  }
}

export function closeManager() {
  let convertermanager = document.getElementById("convertermanager");

  //document.getElementById("ToolbarManagerContainer").style.display = "none";
  var x = document.getElementsByClassName("ToolbarManagerContainer");
  var i;
  for (i = 0; i < x.length; i++) {
    x[i].style.display = "none";
  }

  let op = 1;
  let timer = setInterval(fadeOut, 5);

  function fadeOut() {
    if (op <= 0.5) {
      clearInterval(timer);
      convertermanager.style.visibility = "hidden";
    }
    convertermanager.style.opacity = op;
    op -= op * 0.5;
  }
  convertermanager.style.width = "280px";
}
